import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';
import {
  UpdateCustomFieldValuesForProjectMutation as _UpdateCustomFieldValuesForProjectMutation,
  UpdateCustomFieldValuesForProjectInput,
} from '@/gql/graphql';

const UpdateCustomFieldValuesForProjectMutation = graphql(`
  mutation UpdateCustomFieldValuesForProject(
    $input: UpdateCustomFieldValuesForProjectInput!
  ) {
    updateCustomFieldValuesForProject(input: $input) {
      customFields {
        field {
          identifier
          isRequired
          label
          type
          options
          schema
        }
        value
      }
    }
  }
`);

const useUpdateCustomFieldValuesForProject = (args?: {
  projectId?: string;
  options?: UseMutationOptions<
    _UpdateCustomFieldValuesForProjectMutation,
    unknown,
    UpdateCustomFieldValuesForProjectInput
  >;
}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args?.options ?? {};
  return useMutation({
    mutationFn: (variables) => {
      return gqlClient.request(UpdateCustomFieldValuesForProjectMutation, {
        input: variables,
      });
    },
    onSuccess: (data, variables, context) => {
      if (args?.projectId) {
        void queryClient.invalidateQueries({
          queryKey: projectKeys.customFields(args.projectId),
        });
        // Pipeline-stage transition validity depends on the current Custom
        // Field values; without this the stage dropdown stays stale until
        // a manual refresh.
        void queryClient.invalidateQueries({
          queryKey: projectKeys.potentialPipelineTransitions(args.projectId),
        });
      }
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useUpdateCustomFieldValuesForProject;
